'use client';

import Image from 'next/image';
import { useQuery } from '@tanstack/react-query';
import { settingAPI } from '@/lib/api';
import { getImageUrl } from '@/lib/utils';

export default function BannerImage() {
  const { data: settingsData } = useQuery({
    queryKey: ['settings'],
    queryFn: () => settingAPI.getAll(),
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  // settingAPI.getAll() 现在直接返回 Settings 对象
  const settings = settingsData || {};
  const bannerImageUrl = settings.homepage_banner_image;

  if (!bannerImageUrl) {
    return null;
  }

  const imageUrl = getImageUrl(bannerImageUrl);

  return (
    <section 
      className="elementor-section elementor-top-section elementor-element elementor-element-1c8b715 elementor-section-full_width elementor-section-height-default elementor-section-height-default" 
      data-id="1c8b715" 
      data-element_type="section"
      style={{
        width: '100%',
        position: 'relative',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        display: 'block',
      }}
    >
      <div 
        className="elementor-container elementor-column-gap-no"
        style={{
          width: '100%',
          padding: 0,
          margin: 0,
        }}
      >
        <div 
          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b4ad612" 
          data-id="b4ad612" 
          data-element_type="column"
          style={{
            padding: 0,
            margin: 0,
            width: '100%',
          }}
        >
          <div 
            className="elementor-widget-wrap elementor-element-populated"
            style={{
              width: '100%',
              padding: 0,
              margin: 0,
            }}
          >
            <div 
              className="elementor-element elementor-element-afb6ecb elementor-widget elementor-widget-image" 
              data-id="afb6ecb" 
              data-element_type="widget" 
              data-widget_type="image.default"
              style={{
                width: '100%',
                padding: 0,
                margin: 0,
              }}
            >
              <div 
                className="elementor-widget-container"
                style={{
                  width: '100%',
                  padding: 0,
                  margin: 0,
                  textAlign: 'center',
                }}
              >
                <img
                  src={imageUrl}
                  alt="Banner"
                  className="attachment-full size-full wp-image-264"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

